import {Page} from "@/libwyze-shared/types";
import React, {ReactElement} from "react";
import {Typography} from "@mui/material";
import {StyledBoxColumn, StyledBoxRow} from "@/shared/StyledComponents";
import {CheckinScreenType, CheckinState, LookupType} from "./CheckinPlayerPreviewFragment";
import {
  EditOutlined,
  PhoneOutlined,
  QrCode2Outlined,
} from "@mui/icons-material";
import {ChooseCard} from "./components/ChooseCard";

export function FindAppointmentScreen(props: {
  practicePage: Page,
  pushScreenType: (st: CheckinScreenType) => void,
  checkinState: CheckinState,
  setCheckinState: (checkin: CheckinState) => void,
}): ReactElement {
  return <>
    <StyledBoxColumn style={{alignItems: "flex-start", gap: 0}}>
      <Typography variant={"h2"} style={{fontWeight: 900}}>
        Let's find your appointment.
      </Typography>
      <Typography style={{fontSize: "100%", opacity: 0.5}}>
        Choose the fastest way for you.
      </Typography>
    </StyledBoxColumn>
    <StyledBoxRow style={{width: "100%", gap: 16}}>
      <ChooseCard
        icon={<QrCode2Outlined/>}
        title="Scan QR code"
        description="Fastest. Open your confirmation email, SMS, or WhatsApp message and hold it up to the camera."
        highlighted={true}
        onClick={() => {
          props.pushScreenType(CheckinScreenType.CHECKIN_QRCODE);
        }}
      />
      <ChooseCard
        icon={<EditOutlined/>}
        title="Enter appointment code"
        description="6-digit code from your confirmation."
        onClick={() => {
          props.pushScreenType(CheckinScreenType.ENTER_APPOINTMENT_CODE);
        }}
      />
      <ChooseCard
        icon={<PhoneOutlined/>}
        title="Use phone number"
        description="We'll match by the number on file."
        onClick={() => {
          props.setCheckinState({...props.checkinState, lookupType: LookupType.APPOINTMENT});
          props.pushScreenType(CheckinScreenType.ENTER_PHONE_NUMBER);
        }}
      />
    </StyledBoxRow>
  </>;
}
